import moment from "moment"
import _ from "lodash"

import type { RefundOptionApiReponse, CalculatorData } from "../records/RefundOption"

export default function mapperRefundOption(input: RefundOptionApiReponse): ?CalculatorData {
  if (!input) {
    return null
  }

  let _pnrs = null
  let _origin = null
  let _credits = null
  let _refundableOptions = null

  if (input.pnrs) {
    _pnrs = {}
    _.forEach(input.pnrs, (x, key) => {
      _pnrs[key] = {
        ...x,
        currency: x.currency.toLowerCase(),
      }
    })
  }

  if (input.refundable_options) {
    _refundableOptions = {}
    if (input.refundable_options.origin) {
      _origin = {}
      _.forEach(input.refundable_options.origin, (x, key) => {
        // key is `credits` `promocode` etc, x is array of payments
        if (key !== "token") {
          _origin[key] = x.map(e => ({
            ...e,
            currency: e.currency.toLowerCase(),
          }))
        } else {
          _origin[key] = x
        }
      })
      _refundableOptions.origin = _origin
    }
    if (input.refundable_options.credits) {
      _credits = {}
      _.forEach(input.refundable_options.credits, (x, key) => {
        // key is `credits` `promocode` etc, x is array of payments
        if (key !== "token") {
          _credits[key] = x.map(e => ({
            ...e,
            currency: e.currency.toLowerCase(),
          }))
        } else {
          _credits[key] = x
        }
      })
      _refundableOptions.credits = _credits
    }
  }
  // map price currencies to lowercase
  const output = {
    type: input.based_on,
    pnrs: _pnrs,
    refundableUntil: input.refundable_until ? moment.utc(input.refundable_until * 1000) : null,
    refundableOptions: _refundableOptions,
  }
  output.cancellationFee = input.cancellation_fee
    ? {
        ...input.cancellation_fee,
        currency: input.cancellation_fee && input.cancellation_fee.currency.toLowerCase(),
      }
    : null
  output.totalAmount = input.total_amount
    ? {
        ...input.total_amount,
        currency: input.total_amount && input.total_amount.currency.toLowerCase(),
      }
    : null

  return output
}
